localStorageRemove();
topHitNews();
sideHitNews();
newsSearch();
raceInfoNav();
// raceInfoNavWeek();
newsPrimarySlider();
horseCheckSlider();
snsShare();
articleDetailMore();
horseCheckRase();
horsePictureSlider();
tableCellHeight();
tableMouseDragScroll();
tooltip();
myForecast();
tableSticky();
tableOldSubject();
// headerSticky();
selectorCenter();
animationStamp();
// localStorageCheck();

function countScroll(e) {
  var x = e.scrollLeft;
  return x;
}

function topHitNews() {
  const query = document.querySelector(".js-top-hit-news");
  if (!query) return;

  const subject = document.querySelector(".js-top-hit-news-subject");
  const items = document.querySelectorAll(".js-top-hit-news-item");

  const itemHeightList = [];

  items.forEach((item) => {
    itemHeightList.push(item.clientHeight);
  });

  const itemMaxHeight = Math.max(...itemHeightList);

  subject.style.height = itemMaxHeight + "px";
  query.style.height = itemMaxHeight + "px";

  var topHitNews = new Swiper(".js-top-hit-news", {
    loop: true,
    slidesPerView: 1,
    direction: "vertical",
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
      waitForTransition: false,
      pauseOnMouseEnter: true,
    },
  });
}

function sideHitNews() {
  const query = document.querySelector(".side-hit-news-slider");
  if (!query) return;

  var sideHitNews = new Swiper(".side-hit-news-slider", {
    loop: true,
    navigation: {
      nextEl: ".side-hit-news-next",
      prevEl: ".side-hit-news-prev",
    },
  });
}

function newsSearch() {
  const query = document.querySelector(".news-search");
  if (!query) return;

  var listSearchNav = new Swiper(".news-search", {
    freeMode: true,
    spaceBetween: 12,
    slidesPerView: "auto",
  });
}

function raceInfoNav() {
  const query = document.querySelector("#js-race-info-nav");
  if (!query) return;

  var raceInfoNav = new Swiper("#js-race-info-nav", {
    slidesPerView: 1,
    spaceBetween: 50,
    grabCursor: false,
    followFinger: false,
    navigation: {
      nextEl: "#js-race-info-nav > .slider-next-small",
      prevEl: "#js-race-info-nav > .slider-prev-small",
    },
  });
}

function raceInfoNavWeek() {
  const query = document.querySelector(".race-info-nav-week-wrapper");
  if (!query) return;

  var listSearchNav = new Swiper(".race-info-nav-week-wrapper", {
    freeMode: true,
    spaceBetween: 12,
    slidesPerView: "auto",
    grabCursor: true,
    nested: true,
  });
}

function articleDetailMore() {
  const articleDetail = document.getElementById("js-article-detail");
  if (!articleDetail) return;

  const body = document.getElementById("js-article-detail-more");
  const btn = document.getElementById("js-article-detail-more-btn");

  btn.addEventListener("click", function () {
    articleDetail.classList.add("is-show");
    body.remove();
  });
}

function newsPrimarySlider() {
  const newsPrimarySliderQuery = document.querySelector(".news-primary-slider");
  if (!newsPrimarySliderQuery) return;
  const sliders = document.querySelectorAll(".news-primary-slider .swiper-slide");
  if (sliders.length == 1) return;

  var newsPrimarySlider = new Swiper(".news-primary-slider", {
    slidesPerView: 1,
    loop: true,
    navigation: {
      nextEl: ".news-primary-slider-next",
      prevEl: ".news-primary-slider-prev",
    },
    pagination: {
      el: ".news-primary-slider-pagination",
    },
  });
}

function horseCheckSlider() {
  const query = document.querySelector("#js-horse-check-slider-main");
  if (!query) return;

  const slides = document.getElementsByClassName('slider-thumb-slide');
  var horseCheckThumb = new Swiper("#js-horse-check-slider-thumb", {
    slidesPerView: 5,
    spaceBetween: 5,
    loop: true,
    loopedSlides: slides.length,
    centeredSlides: true,
    navigation: {
      nextEl: "#js-horse-check-slider-thumb > .slider-next-small",
      prevEl: "#js-horse-check-slider-thumb > .slider-prev-small",
    },
  });

  var horseCheckMain = new Swiper("#js-horse-check-slider-main", {
    loop: true,
    loopedSlides: slides.length,
    effect: "coverflow",
    speed: 1500,
    autoplay: {
      delay: 3500,
      disableOnInteraction: false,
      waitForTransition: false,
      pauseOnMouseEnter: true,
    },
    controller:{
      control:horseCheckThumb
    },
    thumbs: {
      swiper: horseCheckThumb,
    },
    navigation: {
      nextEl: "#js-horse-check-slider-main > .slider-next",
      prevEl: "#js-horse-check-slider-main > .slider-prev",
    },
  });
}

function snsShare() {
  const snsShareQuery = document.querySelector(".sns-share");
  if (!snsShareQuery) return;

  const shareUrl = location.href;
  const shareHostPath = location.host + location.pathname;
  const shareTitle = document.title;

  // twitter
  const shareTwitter = document.getElementById("js-share-twitter");
  shareTwitter.setAttribute("href", "https://twitter.com/intent/tweet?url=" + shareUrl + "&text=" + shareTitle);

  // facebook
  const shareFacebook = document.getElementById("js-share-facebook");
  shareFacebook.setAttribute("href", "http://www.facebook.com/share.php?u=" + shareUrl);

  // line
  const shareLine = document.getElementById("js-share-line");
  shareLine.setAttribute("href", "https://social-plugins.line.me/lineit/share?url=" + shareUrl);

  // hatena
  const shareHatena = document.getElementById("js-share-hatena");
  shareHatena.setAttribute("href", "http://b.hatena.ne.jp/entry/s/" + shareHostPath);
}

function horseCheckRase() {
  const query = document.querySelector(".horse-check-race-item");
  if (!query) return;

  const btns = document.querySelectorAll(".horse-check-race-subject");

  for (let i = 0; i < btns.length; i++) {
    const btn = btns[i];
    const contents = btn.nextElementSibling;
    const icon = btn.querySelector(".horse-check-race-icon");

    btn.addEventListener("click", function () {
      btn.classList.toggle("is-active");
      icon.classList.toggle("is-active");
      contents.classList.toggle("is-show");
    });
  }
}

function horsePictureSlider() {
  const query = document.querySelector("#js-horse-picture-slider-main");
  if (!query) return;
  let url = new URL(window.location.href);
  let params = url.searchParams;
  let selectPhotoInd = (params.get('ph') ?? params.get('pp')) - 1;
  var horsePictureThumb = new Swiper("#js-horse-picture-slider-thumb", {
    slidesPerView: 7.8,
    spaceBetween: 10,
    centeredSlides: true,
    loop: false,
    initialSlide: selectPhotoInd,
    navigation: {
      nextEl: "#js-horse-picture-slider-thumb > .slider-next-small",
      prevEl: "#js-horse-picture-slider-thumb > .slider-prev-small",
    },
  });
  var horsePictureMain = new Swiper("#js-horse-picture-slider-main", {
    loop: true,
    initialSlide: selectPhotoInd,
    navigation: {
      nextEl: "#js-horse-picture-slider-main > .slider-next",
      prevEl: "#js-horse-picture-slider-main > .slider-prev",
    },
    thumbs: {
      swiper: horsePictureThumb,
    },
  });
}

function tableCellHeight() {
  const query = document.querySelector(".race-detail-table");
  if (!query) return;

  const cells = document.querySelectorAll(".js-cell-height");
  for (let i = 0; i < cells.length; i++) {
    const cell = cells[i];
    const cellHeight = cell.clientHeight;

    const target = document.getElementById("js-scroll-target");
    const body = target.querySelector("tbody");
    const list = body.querySelectorAll("tr");
    const li = list[i];
    const anchor = li.querySelectorAll(".js-cell");
    // anchor[0].style.height = cell.clientHeight + "px";
    anchor[0].style.height = cell.getBoundingClientRect().height + "px";
  }
}

function tableMouseDragScroll(){
  const query = document.querySelector("#js-scroll-target");
  if (!query) return;

  let target;
  $(query).each(function (i, e) {
    $(e).mousedown(function (event) {
      event.preventDefault();
      target = $(e);
      $(e).data({
        down: true,
        move: false,
        x: event.clientX,
        y: event.clientY,
        scrollleft: $(e).scrollLeft(),
        scrolltop: $(e).scrollTop(),
      });
      return false;
    });
    $(e).click(function (event) {
      if ($(e).data("move")) {
        return false;
      }
    });
  });
  $(document)
    .mousemove(function (event) {
      if ($(target).data("down")) {
        event.preventDefault();
        let move_x = $(target).data("x") - event.clientX;
        let move_y = $(target).data("y") - event.clientY;
        if (move_x !== 0 || move_y !== 0) {
          $(target).data("move", true);
        } else {
          return;
        }
        $(target).scrollLeft($(target).data("scrollleft") + move_x);
        $(target).scrollTop($(target).data("scrolltop") + move_y);
        return false;
      }
    })
    .mouseup(function (event) {
      $(target).data("down", false);
      return false;
    });
}

function tooltip() {
  const query = document.querySelector(".tooltip");
  if (!query) return;

  const icons = document.querySelectorAll(".icon-info");
  const contents = document.getElementById("js-tooltip-contents");
  const contentsRect = contents.getBoundingClientRect();
  const contentsX = contentsRect.left;
  const contentsY = contentsRect.top;

  const targetTooltipSp = document.getElementById("js-tooltip-sp");
  const windowWidth = window.innerWidth;
  const tooltipSpWidth = targetTooltipSp.clientWidth;

  function tooltipSp(windowWidth) {
    const w = windowWidth;
    windowWidthDiff = 1431 - w;
    const n = tooltipSpWidth - windowWidthDiff;
    const tm = 270;

    function base(w, n) {
      if (w < 1431) {
        if (n > tm) {
          targetTooltipSp.style.width = n + "px";
        } else {
          targetTooltipSp.style.width = tm + "px";
        }
      }
    }

    base(w, n);

    window.addEventListener("resize", () => {
      const innerWindowWidth = window.innerWidth;
      const tooltipResizeWidth = targetTooltipSp.clientWidth;

      base(innerWindowWidth, tooltipResizeWidth);
    });
  }

  tooltipSp(windowWidth);

  for (let i = 0; i < icons.length; i++) {
    const icon = icons[i];
    const iconRect = icon.getBoundingClientRect();
    const iconWidth = icon.clientWidth;
    const iconX = iconRect.left;
    const iconY = iconRect.top;
    const dataTooltip = icon.dataset.tooltip;

    function hoverEvent() {
      icon.addEventListener(
        "mouseenter",
        () => {
          icon.classList.toggle("is-active");
          tooltip.style.visibility = "visible";
        },
        false
      );

      icon.addEventListener(
        "mouseleave",
        () => {
          icon.classList.toggle("is-active");
          tooltip.style.visibility = "hidden";
        },
        false
      );
    }

    const tooltip = document.getElementById("js-tooltip-" + dataTooltip);
    const target = document.getElementById("js-scroll-target");

    target.addEventListener("scroll", () => {
      tooltip.style.visibility = "hidden";
    });

    function setTooltip(scrollX) {
      const cr = contents.getBoundingClientRect();
      const cx = cr.left;
      const iconSp = document.getElementById("js-tooltip-icon-sp");
      const ir = iconSp.getBoundingClientRect();
      const ix = ir.left;
      const tsw = targetTooltipSp.clientWidth;
      const tsf = targetTooltipSp.querySelector(".tooltip-arrow-front");
      const tsb = targetTooltipSp.querySelector(".tooltip-arrow-back");

      const tooltipHeight = tooltip.clientHeight;
      const tooltipsX = iconX - contentsX;
      tooltip.style.left = tooltipsX - scrollX + "px";
      tooltip.style.marginLeft = iconWidth / 2 + "px";

      if (cx + 20 < tooltipSpWidth / 2) {
        targetTooltipSp.style.left = tsw / 2 - cx - scrollX + "px";

        tsf.style.marginLeft = -tsw / 2 + ix + "px";
        tsb.style.marginLeft = -tsw / 2 + ix + "px";

        if (cx < 5) {
          tsf.style.marginLeft = -120 + "px";
          tsb.style.marginLeft = -120 + "px";
        }
      }

      const tooltipsY = iconY - contentsY;
      tooltip.style.top = -(tooltipHeight - tooltipsY + iconWidth * 2) + "px";
      tooltip.style.marginTop = iconWidth + 1 + "px";
    }

    if (tooltip) {
      setTooltip(0);
      hoverEvent();

      target.addEventListener("scroll", () => {
        //const scrollX = countScroll(target);
        //setTooltip(scrollX);
        setTooltip(0);
      });

      window.addEventListener("resize", () => {
        setTooltip(0);
      });
    }
  }
}

function isEmpty(obj) {
  return !Object.keys(obj).length;
}

function myForecast() {
  const query = document.querySelector(".btn-my-forecast");
  if (!query) return;
  const tableData = document.getElementById("js-table");
  if (!tableData) return;

  const btns = document.querySelectorAll(".btn-my-forecast");
  const raceId = tableData.dataset.race;

  for (let i = 0; i < btns.length; i++) {
    const btn = btns[i];
    const parent = btn.parentNode;

    parent.style.zIndex = 3;

    const tooltip =
      "<div class='tooltip-forecast'><button class='tooltip-forecast-mark' data-forecast='◎'>◎</button><button class='tooltip-forecast-mark' data-forecast='〇'>〇</button><button class='tooltip-forecast-mark' data-forecast='▲'>▲</button><button class='tooltip-forecast-mark' data-forecast='△'>△</button><button class='tooltip-forecast-mark' data-forecast='★'>★</button><button class='tooltip-forecast-mark' data-forecast='削'>削除</button></div>";
    btn.insertAdjacentHTML("afterend", tooltip);
    const tooltipElement = btn.nextElementSibling;

    const btnWidth = btn.clientWidth;
    const btnHeight = btn.clientHeight;
    const parentHeight = parent.clientHeight;
    const parentWeight = parent.clientWidth;
    const targetPositionX = (parentWeight - btnWidth) / 2;
    const targetPositionY = parentHeight / 2 + btnHeight / 2;

    tooltipElement.style.top = targetPositionY + 7 + "px";
    tooltipElement.style.left = targetPositionX - 1 + "px";

    const horseNo = btn.closest("tr").dataset.horse;
    const dataKey      = raceId + '-' + horseNo + "-mark";
    const dataKey_time = raceId + "-time";
    const oldData = localStorage.getItem(dataKey);

    if (oldData != null) {
      btn.textContent = oldData;
    }

    btn.addEventListener("click", function (e) {
      e.target.parentNode.classList.toggle("is-active");
      if (e.target.parentNode.classList.contains("is-active")) {
        tooltipElement.classList.add("is-show");
      } else {
        tooltipElement.classList.remove("is-show");
      }

      btns.forEach(function (btn, index) {
        if (i !== index) {
          btn.classList.remove("is-active");
          btn.nextElementSibling.classList.remove("is-show");
        }
      });
    });

    const marks = tooltipElement.querySelectorAll(".tooltip-forecast-mark");

    for (let i = 0; i < marks.length; i++) {
      const mark = marks[i];
      const markData = mark.dataset.forecast;

      mark.addEventListener("click", function () {
        tooltipElement.classList.remove("is-show");
        btn.parentNode.classList.remove("is-active");
        if (markData == "削") {
          btn.textContent = "…";
          localStorage.removeItem(dataKey);
          localStorage.removeItem(dataKey_time);
        } else {
          btn.textContent = markData;
          localStorage.setItem(dataKey, markData);
          localStorage.setItem(dataKey_time, Date.now());
        }
      });
    }
  }
}

function localStorageCheck() {
  var date = new Date();
  var nowDate = Math.floor(date.getTime() / 1000);

  if (localStorage["forecast"]) {
    var forecastObj = JSON.parse(localStorage["forecast"]);
    var result = [];
    for (let race in forecastObj) {
      var expire = forecastObj[race]["expire"];
      if (expire < nowDate) {
        result.push(race);
      }
    }

    result.forEach((race) => {
      delete forecastObj[race];
    });

    if (isEmpty(forecastObj)) {
      localStorage.removeItem("forecast");
    } else {
      var forecastObjJson = JSON.stringify(forecastObj);
      localStorage.setItem("forecast", forecastObjJson);
    }
  }
}
// localStorage 保存期間が過ぎている場合は削除
function localStorageRemove() {
  const period = 1000*60*60**24*30; // localStorage 保存期間 30days
  for (let i=0; i<localStorage.length; i++) {
    let key = localStorage.key(i);
    let result = key.match(/^(\d+).*-mark/);
    if (result != null) {
      let df = Date.now() - parseFloat(localStorage.getItem(result[1] + "-time"));
      if(df > period) {
        localStorage.removeItem(result[0]);
        localStorage.removeItem(result[1] + "-time");
      }
    }
  }
}

function tableSticky() {
  const query = document.querySelector(".table-fixed");
  if (!query) return;

  const head = document.querySelector(".table-head");
  const body = document.querySelector(".table-body");

  const headRow = head.querySelectorAll("tr");
  const bodyRow = body.querySelectorAll("tr");

  function row(row) {
    masterWidthList = [];
    for (let i = 0; i < row.length; i++) {
      if (i == 0) {
        const r = row[i];
        const targets = r.querySelectorAll(".table-fixed");
        for (let i = 0; i < targets.length; i++) {
          const target = targets[i];
          const targetWidth = target.offsetWidth;
          masterWidthList.push(targetWidth);
        }
      }
    }

    row.forEach(function (row) {
      const targets = row.querySelectorAll(".table-fixed");
      const widthList = [];

      for (let i = 0; i < targets.length; i++) {
        const target = targets[i];
        const targetWidth = target.offsetWidth;
        const width = widthList.reduce((sum, element) => sum + element, 0);

        if (i > 0) {
          target.style.left = width + "px";
          if (targets.length < 10 && i > 0) {
            target.style.left = masterWidthList[1] + width + "px";
          } else {
            target.style.left = width + "px";
          }
        }
        widthList.push(targetWidth);
      }
    });
  }
  row(headRow);
  row(bodyRow);
}

function tableOldSubject() {
  const subject = document.getElementById("js-table-subject-sticky");
  if (!subject) return;

  const target = document.getElementById("js-scroll-target");
  target.addEventListener("scroll", () => {
    const scrollX = countScroll(target);
    subject.style.marginLeft = scrollX + "px";
  });
}

function headerSticky() {
  const header = document.querySelector(".header");
  if (!header) return;

  const headerHeight = header.clientHeight;
  const contents = document.querySelector(".page-contents");
  const contentsFull = document.querySelector(".page-contents-full");

  if (contents) {
    contents.classList.add("js-header-target");
  } else if (contentsFull) {
    contentsFull.classList.add("js-header-target");
  }

  const target = document.querySelector(".js-header-target");
  const targetRect = target.getBoundingClientRect();
  const targetTop = targetRect.top;

  let pos = 0;

  window.addEventListener("scroll", function () {
    let scroll = document.documentElement.scrollTop;

    if (pos < scroll) {
      header.classList.remove("is-show");
      header.classList.add("is-hide");
      if (pos < targetTop + headerHeight) {
        header.classList.add("is-show");
        header.classList.remove("is-hide");
      } else {
        header.classList.remove("is-show");
        header.classList.add("is-hide");
      }
    } else {
      header.classList.remove("is-hide");
      header.classList.add("is-show");
    }

    pos = document.documentElement.scrollTop;
  });
}

function selectorCenter() {
  $(".schedule-nav-select").on("change", function () {
    var $this = $(this);
    var $option = $this.find("option:selected");
    $(".schedule-nav-selector-label").text($option.text());

    // onchange後にフォーカスしてるのが嫌な場合
    $this.blur();
  });
}

function animationStamp() {
  let once = false;
  window.addEventListener("scroll", function () {
    const cards = document.querySelectorAll(".card-hit");
    cards.forEach((card) => {
      const cardPosition = card.getBoundingClientRect().top;

      if (cardPosition <= window.innerHeight - 300 && once !== true) {
        const icon = card.querySelector(".card-hit-icon");
        icon.classList.add("is-show");
      }
    });
  });
}

function anime_horse_run($t) {
  $d = $t.data("speed");
  $l = parseInt($t.css("left")) - parseInt($d);
  $ww = $(window).innerWidth();
  if ($l < -200) {
    $s = Math.floor(Math.random() * 10) + 10;
    $t.data("speed", $s);
    $t.css("left", $ww + 100);
  } else {
    $t.css("left", $l);
  }
}

$(window).on("load", function () {
  $mh = $(".main-visual").height();
  $cont = $('<div class="main-visual-race">');
  if ($mh < 400) {
    $num = 4;
  } else {
    $num = 7;
  }

  $ww = $(window).innerWidth();
  for ($n = 0; $n < $num; $n++) {
    $r = Math.floor(Math.random() * 1000);
    $s = Math.floor(Math.random() * 10) + 10;
    $l = $ww + Math.floor(Math.random() * 100) + 100;
    $horse = $('<div class="main-visual-horse" data-speed="' + $s + '" id="horse-' + $n + '">');
    $horse.css("left", $l);
    $cont.append($horse);
  }

  $(".main-visual").prepend($cont);

  setInterval(function () {
    for ($n = 0; $n < $num; $n++) {
      anime_horse_run($("#horse-" + $n));
    }
  }, 200);

  $(".main-visual-race").animate(
    {
      backgroundPosition: "+=41px",
    },
    4000,
    "linear"
  );

  setInterval(function () {
    $(".main-visual-race").animate(
      {
        backgroundPosition: "+=41px",
      },
      4000,
      "linear"
    );
  }, 4000);
});
